/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-cond-assign */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-template */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable camelcase */
import React, {
  SetStateAction,
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
// import styles from './Sai.css';
import {
  ArrowUpward,
  AttachFile,
  Clear,
  Flare,
  GetApp,
  Launch,
  WarningOutlined,
} from "@material-ui/icons";
import { Box, Modal, Tooltip } from "@material-ui/core";
import style from "./Sai.module.css";
import SAI_pfp from "../icons/ai1026.png";

const SAI_DEFAULT_MESSAGE =
  "Hello! I am SAi! I am your helpful data analytics assistant. Please let me know how I can help.";
const SAI_DEFAULT_TRANSCRIPT = {
  threadId: "",
  messages: [
    {
      id: "System Message",
      object: "thread.message",
      created_at: Date.now(),
      assistant_id: "System",
      thread_id: "System",
      run_id: "System",
      role: "assistant",
      content: [
        {
          type: "text",
          text: {
            value:
              "Hello! I am SAi! I am your helpful data analytics assistant. Please let me know how I can help.",
            annotations: [],
          },
        },
      ],
    },
  ],
};
export const StarSVG = () => {
  return (
    <svg
      id="eVX4dGfmUEw1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 40 40"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      project-id="aa417334ced04ba29c3f9ca876131d59"
      export-id="10aad9eee7e74c90bee74b950b98d733"
      width="20"
      height="20"
    >
      <defs>
        <linearGradient
          id="eVX4dGfmUEw2-fill"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          spreadMethod="pad"
          gradientUnits="objectBoundingBox"
          gradientTransform="translate(0 0)"
        >
          <stop
            id="eVX4dGfmUEw2-fill-0"
            offset="0%"
            stopColor="rgba(17,87,227,0.53)"
          />
          <stop
            id="eVX4dGfmUEw2-fill-1"
            offset="100%"
            stopColor="rgba(123,29,213,0.51)"
          />
        </linearGradient>
      </defs>
      <path
        d="M-1.368449,-27.959455c0,0,3.200832,14.087746,7.521073,18.285919s19.069934,7.211861,19.069934,7.211861-14.749694,3.013689-19.069934,7.211862-7.521073,18.285919-7.521073,18.285919-3.200832-14.087746-7.521072-18.285919-19.069934-7.211862-19.069934-7.211862s14.749694-3.013689,19.069934-7.211861s7.521072-18.285919,7.521072-18.285919Z"
        transform="matrix(.752134 0 0 0.784382 20.860906 21.930896)"
        fill="url(#eVX4dGfmUEw2-fill)"
        strokeWidth="0"
      />
    </svg>
  );
};

interface ITranscriptEntity {
  id: string;
  object: "thread.message" | string;
  created_at: number;
  assistant_id: string | number | null;
  thread_id: string;
  run_id: string | number | null;
  role: "user" | "assistant";
  content: Array<{
    type: "text" | "image_blob" | "image_file";
    text?: {
      value: string;
      annotations: string[];
    };
    blob?: string;
    image_file?: {
      fileId?: string;
    };
  }>;
  attatchments?: any;
  metadata?: any;
}

interface ITranscript {
  threadId: string;
  messages: ITranscriptEntity[];
}

const richerText = (text: string): (string | JSX.Element)[] => {
  const regex = /\*\*(\S(.*?\S)?)\*\*/g;
  const result: (string | JSX.Element)[] = [];
  let last = 0;
  let match;
  while ((match = regex.exec(text)) !== null) {
    const [fullMatch, boldText] = match;
    const start = match.index;

    if (start > last) {
      result.push(text.slice(last, start));
    }
    result.push(
      <strong style={{ fontWeight: 900 }} key={start}>
        {boldText}
      </strong>
    );
    last = start + fullMatch.length;
  }
  if (last < text.length) {
    result.push(text.slice(last));
  }
  return result;
};

const openImgInNewTab = (base64: string) => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: "image/png" });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
};

const TranscriptRenderer = ({
  transcript,
  userUri,
  setModal,
  lightMode,
}: {
  transcript: ITranscriptEntity;
  userUri: string;
  setModal: React.Dispatch<SetStateAction<string | undefined>>;
  lightMode: boolean;
}) => {
  const { role, content } = transcript;
  const [isHover, setIsHover] = useState(false);

  const timeRenderer = (timestamp: number): JSX.Element => {
    const getTimeDifference = (ts: number): string => {
      const now = Math.floor(Date.now() / 1000);
      const tsInSeconds = Math.floor(ts / 1000);
      const diff = now - tsInSeconds;

      if (diff < 60) return "Just now";
      if (diff < 3600) {
        const minutes = Math.floor(diff / 60);
        return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
      }

      const hours = Math.floor(diff / 3600);
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    };

    return <span>{getTimeDifference(timestamp)}</span>;
  };
  if (role === "assistant") {
    return (
      <div
        className={
          lightMode ? style.assistantBubble : style.assistantBubbleDark
        }
      >
        {content &&
          content.length &&
          content.map((c, i) => {
            if (c.type === "text") {
              if (c.text!.value === SAI_DEFAULT_MESSAGE) {
                return (
                  <span
                    style={{ position: "relative" }}
                    className={style.newPrompt}
                  >
                    <img
                      alt="profile-img"
                      src={SAI_pfp}
                      className={style.saiImg}
                    />
                    {c.text!.value}
                  </span>
                );
              }
              return (
                <span style={{ position: "relative" }} className="notranslate">
                  <img
                    alt="profile-img"
                    src={SAI_pfp}
                    className={style.saiImg}
                  />
                  {richerText(c.text!.value)}
                </span>
              );
            }
            if (c.type === "image_blob") {
              return (
                <div
                  className={
                    lightMode ? style.imageContainer : style.imageContainerDark
                  }
                >
                  <img
                    onClick={() => setModal(`data:image/png;base64,${c.blob}`)}
                    className={style.generatedImage}
                    style={{ height: 400, width: 400 }}
                    src={`data:image/png;base64,${c.blob}`}
                    alt={c.blob}
                  />
                  <div style={{ display: "flex" }}>
                    <a
                      title="Download"
                      href={`data:image/png;base64,${c.blob}`}
                      download
                    >
                      <GetApp
                        fontSize="small"
                        style={{ color: lightMode ? "#666" : "#888" }}
                      />
                    </a>
                    <a
                      onClick={() => openImgInNewTab(`${c.blob}`)}
                      title="Open in new tab"
                    >
                      <Launch
                        fontSize="small"
                        style={{ color: lightMode ? "#666" : "#888" }}
                      />
                    </a>
                  </div>
                </div>
              );
            }

            return <></>;
          })}
      </div>
    );
  }
  const index = content.findIndex((c) => c.type === "text");
  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      className={lightMode ? style.userBubble : style.userBubbleDark}
    >
      <img
        alt="profile-img"
        src={userUri || "./default-user-image.ico"}
        className={style.userImg}
      />
      <span className="notranslate">{content[index]?.text?.value}</span>
      {isHover && (
        <span className={style.timeStamp}>
          Sent: {timeRenderer(transcript.created_at)}
        </span>
      )}
    </div>
  );
};

const getLatestRowData = (gridApi: any) => {
  const updatedData: any[] = [];
  gridApi.forEachNode((node: any) => updatedData.push(node.data));

  return updatedData;
};

function Sai({
  mode,
  userUri,
  token,
  userLeaderboardApi,
}: {
  mode: string;
  userUri: string | undefined;
  token: string;
  userLeaderboardApi: any;
}) {
  // we want to provide a "typing..." visual when a request is sent to the bot
  const [waiting, setWaiting] = useState(false);

  // assign the textarea a state on change
  const [textValue, setTextValue] = useState("");

  // using a container ref, allowing us to "snap" back down to the most recent message on transcript change.
  const chatContainerRef = useRef<HTMLDivElement>();

  // setting a string to a modal for full screen viewing
  const [modal, setModal] = useState<string | undefined>(undefined);

  // Transcript with system message
  const [transcript, setTranscript] = useState<ITranscript>({
    threadId: "",
    messages: [
      {
        id: "System Message",
        object: "thread.message",
        created_at: Date.now(),
        assistant_id: "System",
        thread_id: "System",
        run_id: "System",
        role: "assistant",
        content: [
          {
            type: "text",
            text: {
              value:
                "Hello! I am SAi! I am your helpful data analytics assistant. Please let me know how I can help.",
              annotations: [],
            },
          },
        ],
      },
    ],
  });

  const newChat = useCallback(async () => {
    setTranscript(SAI_DEFAULT_TRANSCRIPT as ITranscript);
  }, [textValue, token, transcript.threadId, setTranscript, setWaiting]);

  const sendMessage = useCallback(async () => {
    try {
      setWaiting(true);
      setTranscript((prev) => ({
        threadId: prev.threadId,
        messages: [
          ...prev.messages,
          {
            id: "System Message",
            object: "thread.message",
            created_at: Date.now(),
            assistant_id: "System",
            thread_id: "System",
            run_id: "System",
            role: "user",
            content: [
              {
                type: "text",
                text: {
                  value: textValue,
                  annotations: [],
                },
              },
            ],
          },
        ],
      }));
      let object;
      if (!transcript.threadId) {
        object = getLatestRowData(userLeaderboardApi.api);
      }
      const res = await fetch(`${process.env.REACT_APP_API_URL}/chat`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          object,
          message: textValue,
          threadId: transcript.threadId,
        }),
      });

      if (!res.ok) {
        throw new Error(`Request failed with status ${res.status}`);
      }

      const data = await res.json();
      if (!data.threadId || !data.message) {
        throw new Error("Invalid response format");
      }

      setTranscript((prev) => ({
        threadId: data.threadId,
        messages: [...prev.messages, data.message],
      }));
    } catch (error) {
      console.error("Failed to send message:", error);
    } finally {
      setWaiting(false);
    }
  }, [textValue, token, transcript.threadId, setTranscript, setWaiting]);

  useEffect(() => {
    const container = chatContainerRef.current;
    if (container) {
      container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
    }
  }, [transcript]);

  useEffect(() => {
    const chatBox = document.getElementById("SAI-chatbox");
    const textArea = document.getElementById("SAI-textarea");

    if (chatBox && textArea) {
      const handleFocus = () => {
        chatBox.style.border =
          mode === "light" ? "2px solid #8cbce266" : "2px solid #555c6f";
      };

      const handleBlur = () => {
        chatBox.style.border = "2px solid transparent";
      };

      textArea.addEventListener("focus", handleFocus);
      textArea.addEventListener("blur", handleBlur);

      return () => {
        textArea.removeEventListener("focus", handleFocus);
        textArea.removeEventListener("blur", handleBlur);
      };
    }
  }, [mode]);

  const lightMode = mode === "light";

  return (
    <div
      prefer-theme={mode}
      className={lightMode ? style.parent : style.parentDark}
    >
      {/* {
        modal && (
          <Modal open={!!modal} disableBackdropClick>
            <div className={style.modalContainer}>
            <Box>
            <button style={{top: -20, right: -20}} type="button" onClick={() => setModal(undefined)}>close</button>
            </Box>
            <img className={style.modalImage} src={modal} alt='ai image' />
            </div>
            </Modal>
        )
      } */}
      <div ref={chatContainerRef as any} className={style.body}>
        {transcript &&
          transcript.messages.map((entity, i) => (
            <TranscriptRenderer
              lightMode={lightMode}
              setModal={setModal}
              userUri={userUri || "./default-user-image.ico"}
              transcript={entity}
            />
          ))}
        {waiting && (
          <span
            className={
              lightMode ? style.assistantBubble : style.assistantBubbleDark
            }
          >
            <span style={{ position: "relative" }}>
              <img alt="profile-img" src={SAI_pfp} className={style.saiImg} />
              <span className={style.animateType}>
                <span className={style.type1}>●</span>
                <span className={style.type2}>●</span>
                <span className={style.type3}>●</span>
              </span>
            </span>
          </span>
        )}
      </div>
      <div
        id="SAI-chatbox"
        className={
          mode === "light"
            ? style.textareaContainer
            : style.textareaContainerDark
        }
      >
        <textarea
          id="SAI-textarea"
          tabIndex={0}
          onKeyDown={(e) => {
            const key = e.code;
            const shiftActive = e.shiftKey;
            if (key === "Enter") {
              if (shiftActive) {
                return;
              }
              e.preventDefault();
              if (textValue.trim().length > 0) {
                setTextValue("");
                sendMessage();
              }
            }
          }}
          value={textValue}
          className={lightMode ? style.textarea : style.textareaDark}
          placeholder="How can I assist you?"
          onChange={(e) => setTextValue(e.target.value)}
        />
        {/* <Tooltip title="add file">
       <label htmlFor="file-upload" className={lightMode ? style.customFileUpload : style.customFileUploadDark}>
          <AttachFile style={{color: lightMode ? "#777" : "white"}} fontSize="small" />
        </label>
       </Tooltip>
        <input id="sai-file-upload" className={style.fileUpload} type="file" /> */}
        <button
          tabIndex={1}
          onClick={() => {
            setTextValue("");
            newChat();
          }}
          title="New Chat"
          // disabled={textValue.trim().length === 0}
          type="button"
          className={lightMode ? style.newChat : style.newChatDark}
        >
          <Flare fontSize="small" />
        </button>
        <button
          tabIndex={1}
          onClick={() => {
            setTextValue("");
            sendMessage();
          }}
          title="Submit"
          disabled={textValue.trim().length === 0}
          type="button"
          className={lightMode ? style.submit : style.submitDark}
        >
          <ArrowUpward fontSize="small" />
        </button>
      </div>
    </div>
  );
}

export default Sai;
